import { enrichInstalledAppData } from '../services/enrich-installed-app-data';
export const convertResponseToProvisionSuccess = _ref => {
  let {
    tenantId,
    installedApps,
    mainInstalledAppId
  } = _ref;
  const {
    [mainInstalledAppId]: mainApp,
    ...mainAppDependencies
  } = installedApps;
  return {
    status: 'SUCCESS',
    installedApps: [enrichInstalledAppData({
      tenantId,
      installedApp: mainApp,
      appId: mainInstalledAppId
    }), ...Object.entries(mainAppDependencies).map(_ref2 => {
      let [appId, installedApp] = _ref2;
      return enrichInstalledAppData({
        appId,
        tenantId,
        installedApp
      });
    })]
  };
};
export const getInstalledApp = (appId, provisionSuccessResponse) => {
  var _provisionSuccessResp;
  return (_provisionSuccessResp = provisionSuccessResponse.installedApps) == null ? void 0 : _provisionSuccessResp.find(installedApp => installedApp.appId === appId);
};
//# sourceMappingURL=provision.js.map